import { render, staticRenderFns } from "./zhongxin.vue?vue&type=template&id=40e29413&scoped=true"
import script from "./zhongxin.vue?vue&type=script&lang=js"
export * from "./zhongxin.vue?vue&type=script&lang=js"
import style0 from "./zhongxin.vue?vue&type=style&index=0&id=40e29413&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e29413",
  null
  
)

export default component.exports